//#region recipes/conversation_view/editor/editor_constants.js
var e = [
	/^https?:\/\//,
	/^http?:\/\//,
	/^ftp?:\/\//,
	/^ftps?:\/\//,
	/^ftps?:\/\//,
	/mailto:([^?]*)/
], t = "https://", n = "#000000", r = {
	EDITOR_SUPPORTED_LINK_PROTOCOLS: e,
	EDITOR_DEFAULT_LINK_PREFIX: t,
	EDITOR_DEFAULT_FONT_COLOR: n
};
//#endregion
export { n as EDITOR_DEFAULT_FONT_COLOR, t as EDITOR_DEFAULT_LINK_PREFIX, e as EDITOR_SUPPORTED_LINK_PROTOCOLS, r as default };

//# sourceMappingURL=editor-constants.js.map